import { UserProfile, UserRole } from "../../../../types/userProfile";
import { getPendingType } from './getPendingType';

/** Minimal set of “facts” used by rules and UI (no external calls). */
export type Facts = {
  role: UserRole;
  isApproved: boolean;
  pendingType: 'none' | 'ai' | 'manual';
  submittedByDisplayName: string | null;
  submittedBySameUser: boolean;
  hasApprovedValue: boolean;
};

/** Builds Facts from currentUser and details.history; single source of truth for rules. */
export function buildFacts(
  currentUser: Pick<UserProfile, 'role' | 'userDisplayName'>,
  details: TranslationDetail
): Facts {
  return {
    role: currentUser.role,
    isApproved: details.translationReview ? false : true,
    pendingType: getPendingType(details.history, details.translationReview),
    submittedByDisplayName: details.translationReview?.author || null,
    submittedBySameUser: details.translationReview?.author === currentUser.userDisplayName,
    hasApprovedValue: !!details.approvedValue,
  };
}
